import React, { useCallback, useState, useEffect } from 'react'
import { Box, Grid, Typography } from '@mui/material';
import { formStyle, stepNumberStyle, formTitleStyle, formDesStyle, underlineStyle, topUnderlineStyle, sectionContainer, smallLabel } from '../../../constant/material_style';
import CustomTextfield from '../../../component/custom_textfield';
import { terms } from '../../../constant/selection';
import moment from 'moment';
import _ from 'lodash';
import { useForm } from 'react-hook-form';
import { formatInitialValue, prefilledData } from '../../../constant/common_use';
import { useStateContext } from '../../../contexts/StepFormContextProvider';
import { handleUpdateForm } from '../../../api/rc_admission_form';

const ServiceAgreementSchedule1 = ({ isAdmin, currentStep, setCurrentStep, formValues, setFormValues }) => {
	const { control, reset, handleSubmit, setValue, formState: { errors }} = useForm({ mode: 'onChange' });
	const { formId } = useStateContext();

	const [inputValue, setInputValue] = useState('');

	useEffect(() => {
		reset(formValues)
	}, [formValues.date_of_agreement, formValues.cr_name, formValues.cr_ic_passport, formValues.cr_address, formValues.cr_mobile, formValues.co_name, formValues.co_ic_passport, formValues.co_address, formValues.co_mobile, formValues.room_assigned, formValues.term, formValues.commencement_date, formValues.security_deposit, formValues.follow_up_hospital]);

	useEffect(() => {
		if(formValues.services === null) {
			const value = formatInitialValue(prefilledData);
			const formattedValue = value
			.split('\n')
			.map(line => {
				const trimmedLine = line.trim();
				return trimmedLine.startsWith('•') ? line : line ? `• ${line}` : '';
			}).join('\n');
			debounceSetValues("services", formattedValue);
		}
	},[])

	const debounceSetValues = useCallback(
		_.debounce((name, value) => {
			setValue(name, value);

			setFormValues((prev) => {
				const newFormValues = { ...prev, [name]: value };
				const updatedValue = {[name]: value};

				if(formId) {
					handleUpdateForm(formId, updatedValue);
				}

				setFormValues(newFormValues);
				return newFormValues;
			});
		}, 500), [setValue, setFormValues, formId]
	);

	const handleChange = (name, value) => {
		console.log(name, value)
		if(name === 'services') {
			const formattedValue = value
			.split('\n')
			.map(line => {
				const trimmedLine = line.trim();
				return trimmedLine.startsWith('•') ? line : line ? `• ${line}` : '';
			}).join('\n');
			debounceSetValues(name, formattedValue);
		} else {
			debounceSetValues(name, value);
		}
	}

	const goback = (e) => {
		setCurrentStep(currentStep - 1);
	}

	const onSubmit = (e) => {
		setCurrentStep(currentStep + 1);
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Box style={formStyle}>
				<Grid container alignItems="flex-start" spacing={2} style={{ marginBottom: '20px', overflowY: 'auto' }}>
					<Grid item>
						<Box style={stepNumberStyle}>{currentStep}</Box>
					</Grid>
					<Grid item xs style={{ paddingLeft: '0' }}>
						<Typography style={formTitleStyle}>Service Agreement - Schedule 1</Typography>
						<Typography style={formDesStyle}>Terms & Condition, PDPA</Typography>
					</Grid>
				</Grid>

				{/* per section */}
				<Box style={sectionContainer}>
					<Box style={topUnderlineStyle}>
						<Typography style={formDesStyle}>Schedule 1</Typography>
					</Box>
				</Box>

				{/* Section 1 */}
				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<CustomTextfield
								name='date_of_agreement' formValue={formValues.date_of_agreement ?? moment()}
								label="1. Date of this Agreement" typeOfField="datePicker" onChangeVal={handleChange} small={false} errors={errors} control={control} readOnly={!isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				{/* Section 2 */}
				<Box style={sectionContainer}>
					<Box style={underlineStyle} />
					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<Grid item xs={12} sm={4}>
								<Typography style={smallLabel}>2. Resident's Details</Typography>
							</Grid>
						</Grid>
					</Grid>

					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<div className='subsection-container'>
								<CustomTextfield
									name='cr_name' formValue={formValues.cr_name ?? ''} readOnly={true} errors={errors} control={control}
									label="2.1. Full Name" typeOfField="text1" small={false} subsection={true}
								/>
							</div>
							<div className='subsection-container'>
								<CustomTextfield
									name='cr_ic_passport' formValue={formValues.cr_ic_passport ?? ''} readOnly={true} errors={errors} control={control}
									label="2.2. IC/Passport" typeOfField="text1" small={false} subsection={true}
								/>
							</div>
							<div className='subsection-container'>
								<CustomTextfield
									name='cr_address' formValue={formValues.cr_address ?? ''} readOnly={true} errors={errors} control={control}
									label="2.3. Address" typeOfField="text1" small={false} subsection={true}
								/>
							</div>
							<div className='subsection-container'>
								<CustomTextfield
									name='cr_mobile' formValue={formValues.cr_mobile ?? ''} readOnly={true} errors={errors} control={control}
									label="2.4. Contact No" typeOfField="phone" small={false} subsection={true}
								/>
							</div>
						</Grid>
					</Grid>
				</Box>

				{/* Section 3 */}
				<Box style={sectionContainer}>
					<Box style={underlineStyle} />
					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<Grid item xs={12} sm={4}>
								<Typography style={smallLabel}>3. Surety's Details</Typography>
							</Grid>
						</Grid>
					</Grid>

					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<div className='subsection-container'>
								<CustomTextfield
									name='co_name' formValue={formValues.co_name ?? ''} readOnly={true} errors={errors} control={control}
									label="3.1. Full Name" typeOfField="text1" small={false} subsection={true}
								/>
							</div>
							<div className='subsection-container'>
								<CustomTextfield
									name='co_ic_passport' formValue={formValues.co_ic_passport ?? ''} readOnly={true} errors={errors} control={control}
									label="3.2. IC/Passport" typeOfField="text1" small={false} subsection={true}
								/>
							</div>
							<div className='subsection-container'>
								<CustomTextfield
									name='co_address' formValue={formValues.co_address ?? ''} readOnly={true} errors={errors} control={control}
									label="3.3. Address" typeOfField="text1" small={false} subsection={true}
								/>
							</div>
							<div className='subsection-container'>
								<CustomTextfield
									name='co_mobile' formValue={formValues.co_mobile ?? ''} readOnly={true} errors={errors} control={control}
									label="3.4. Contact No" typeOfField="phone" small={false} subsection={true} onChangeVal={handleChange}
								/>
							</div>
						</Grid>
					</Grid>
				</Box>

				{/* Section 4 */}
				<Box style={sectionContainer}>
					<Box style={underlineStyle} />
					<Grid container spacing={2}>
						<Grid item xs={12} sm={12}>
							<CustomTextfield name='services' formValue={formValues.services ?? formatInitialValue(prefilledData)} label="4. Services" typeOfField="multilineText1" onChangeVal={handleChange} minRow={6} small={false} errors={errors} control={control} readOnly={!isAdmin} isAdmin={isAdmin} showPlaceholder={true}/>
						</Grid>
					</Grid>
				</Box>

				{/* Section 5 */}
				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<CustomTextfield
								name='room_assigned' formValue={formValues.room_assigned ?? ''} readOnly={true}
								label="5. Room" typeOfField="text" small={false} isAdmin={isAdmin} showPlaceholder={false}
							/>
						</Grid>
					</Grid>
				</Box>

				{/* Section 6 */}
				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<CustomTextfield
								name='term' formValue={formValues.term ?? ''} label='6. Term' typeOfField="autoComplete" small={false} errors={errors} control={control}
								onChangeVal={handleChange} selectLists={terms} inputValue={inputValue} setInputValue={setInputValue} readOnly={!isAdmin} isAdmin={isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				{/* Section 7 */}
				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<CustomTextfield
								name='commencement_date' formValue={formValues.commencement_date ?? moment()} errors={errors} control={control}
								label="7. Commencement Date" typeOfField="datePicker" onChangeVal={handleChange} small={false} readOnly={!isAdmin} isAdmin={isAdmin}
							/>
						</Grid>
					</Grid>
				</Box>

				{/* Section 8 */}
				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<CustomTextfield name='security_deposit' formValue={formValues.security_deposit ?? ''} errors={errors} control={control}
							label="8. Security Deposit" typeOfField="text1" onChangeVal={handleChange} small={false} readOnly={!isAdmin} isAdmin={isAdmin}/>
						</Grid>
					</Grid>
				</Box>

				{/* Section 9 */}
				<Box style={sectionContainer}>
					<Box style={underlineStyle} />
					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<Grid item xs={12} sm={4}>
								<Typography style={smallLabel}>9. Hospital</Typography>
							</Grid>
						</Grid>
					</Grid>

					<Grid container spacing={2}>
						<Grid item xs={12} sm={10}>
							<div className='subsection-container'>
								<CustomTextfield
									name='follow_up_hospital' formValue={formValues.follow_up_hospital ?? ''} readOnly={true}
									label="9.1. Hospital Name" typeOfField="text" small={false} subsection={true} 
								/>
							</div>
						</Grid>
					</Grid>
				</Box>

				<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
					<button className='t-accept-button' onClick={goback}>Previous</button>
					<button type="submit" className='t-accept-button'>Next</button>
				</div>
			</Box>
		</form>
	)
}

export default ServiceAgreementSchedule1